<script setup>
import { defineProps, defineEmits } from 'vue';

const emit = defineEmits(['confirm', 'cancel']);
const onConfirm = () => emit('confirm');
const onCancel = () => emit('cancel');
</script>

<template>
    <div class="modal fade confirmation-modal-box" id="deleteConfirmationModal" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <!-- <div class="modal-header">
                    <h3 class="modal-title">{{$t('delete', 'Delete')}}</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">&#10006;</button>
                </div> -->
                <div class="modal-body">
                    <div class="delete-content">
                        <h3>{{$t('delete-request', 'Delete Request')}}?</h3>
                        <p>{{$t('are-you-sure-want-to-delete-this-request', 'Are you sure you want to, delete this Request?')}}</p>
                    </div>
                    <div class="header-but  info-footer">
                        <button type="button" class="thm-but thm-bor-but"  @click="onCancel" >{{$t('no', 'No')}}</button>
                        <a href="javascript:void(0)" class="thm-but" @click="onConfirm">{{$t('yes', 'Yes')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
#confirmationModal {
    z-index: 9999 !important;
}
</style>